import { useNavigate } from "react-router-dom";
import { CustomAutocomplete, CustomAutocompleteDynamicSearch, CustomTextArea, CustomTextFieldNoForm, CustomTextFieldNumberComponente, GeneralTable } from "@/shared/components/ui";
import { useFetchMotivosRechazo } from "@/shared/actions/erp";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useTableColumnsProspecto } from "@/shared/hooks/useTableColumnsProspecto";
import {
  EstadoProspectoEnum, gridSizeMdLg12, gridSizeMdLg6, hasAllPermissions, hasPermission, ModulosEnumChoice, newEditarProspecteoSchema,
  RolChoiceEnum,
  ROUTER_PATHS, TABLE_CONSTANTS, texto
} from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useEffect, useState } from "react";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import PostAddIcon from '@mui/icons-material/PostAdd';
import { FormEditProspecto, MotivoRechazo } from "@/shared/interfaces";
import { Visibility } from "@mui/icons-material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useGetProspectoCorporativo, usePutProspectoCorporativo } from "@/shared/actions/erp/prospecto_corporativo.actions";
import { IMotivoRechazoCorporativo, IProspectoCorporativo } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import { newMotivoProspecteoCorporativoSchema } from "@/shared/utils/validation-schemas/erp/ventas/prospecto/prospecto_corporativo.schema";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { useAuthStore } from "@/store/auth";
import { Empleado } from "@/shared/interfaces/erp/empleados";
import { useFetchEmpleados } from "@/shared/actions/erp/empleados";

interface TableProspectoCorporativoProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  estado_prospecto?: EstadoProspectoEnum
}

interface IFormChangeVendedor {
  vendedor_actual?: string
  vendedor_nuevo?: string;
  id_prospecto_corporativo?: string
}


export default function TableProspectoCorporativo({
  showCustomActionBtnSpace = true,
  enableEditing = true,
  estado_prospecto = EstadoProspectoEnum.EN_ESPERA

}: TableProspectoCorporativoProps) {


  const navigate = useNavigate();
  const {
    rol: ROL_USUARIO,
    // canal_venta: CANAL_VENTA_USUARIO,
  } = useAuthStore(s => s.user!);

  ///* use state
  const [modal, setModal] = useState(false);
  const [modalCancelar, setModalCancelar] = useState(false);
  const [changeVendedorModal, setChangeVendedorModal] = useState(false);
  const [searchVendedor, setSearchVendedor] = useState("");


  ///* form
  const form = useForm<FormEditProspecto>({
    resolver: yupResolver(newEditarProspecteoSchema),
  });

  const formChangeVendedor = useForm<IFormChangeVendedor>({
    defaultValues: {
      vendedor_nuevo: ""
    }
  })


  const {
    reset,
    control,
    formState: { errors },
  } = form;

  const formRechazo = useForm<IMotivoRechazoCorporativo>({
    resolver: yupResolver(newMotivoProspecteoCorporativoSchema)
  });

  const {
    reset: resetMotivoRechazar,
  } = formRechazo;

  ///* Hooks
  const {
    columnsBaseCorporativo,
    columnsBaseCorporativoFallido
  } = useTableColumnsProspecto({ estado_prospecto: EstadoProspectoEnum.EN_ESPERA });

  const {
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,

    setPagination,
    vendedor,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.PROSPECTO_CORPORATIVO,
    page_size: 100,

  });

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: prospectoRes, isRefetching } =
    useGetProspectoCorporativo({
      page: pageIndex + 1,
      identificacion: searchTerm,
      estado_prospecto: estado_prospecto,
      fecha_solicitud_before: dateBefore,
      fecha_solicitud_after: dateAfter,
      page_size: pageSize,
      user_create: vendedor,
      ...filterObject,
      filterByState: false
    });

  const { mutateAsync: mutateAsyncProspectoCorp } = usePutProspectoCorporativo({
    enableAlert: true
  });

  const { data: dataEmpleadosFiltered, isLoading: isLoadingEmpleados } = useFetchEmpleados({
    enabled: searchVendedor.length > 2,
    params: {
      // canal_venta: CANAL_VENTA_USUARIO!,
      razon_social: searchVendedor,
      page_size: 5
    }
  })



  ///* Funciones

  const onEdit = (preventa: IProspectoCorporativo) => {
    navigate(`${ROUTER_PATHS.ventasCorporativas.preventaCorporativoCrearNav}/${preventa.id_prospecto_corporativo}`);
  }
  const onReview = (prospecto: IProspectoCorporativo) => {
    navigate(`${ROUTER_PATHS.ventasCorporativas.prospectoCorporativoNav}/editar/${prospecto.id_prospecto_corporativo}`);
  }

  useEffect(() => {
    console.log({ dataempleado: formChangeVendedor.watch().vendedor_nuevo })

  }, [formChangeVendedor.watch().vendedor_nuevo]);


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<IProspectoCorporativo>
            columns={estado_prospecto != EstadoProspectoEnum.CANCELADO
              ? columnsBaseCorporativo
              : columnsBaseCorporativoFallido
            }
            data={prospectoRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}
            // onGlobalFilterChange={setGlobalFilter}
            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={prospectoRes?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_BIG}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  {
                    hasPermission(PermissionsEnum.api_add_preventacoorporativa) && (value.estado_prospecto == EstadoProspectoEnum.EN_ESPERA) && (
                      <Grid item >
                        <Tooltip title={'Crear Preventa'} placement="top">
                          <IconButton
                            onClick={() =>
                              onEdit(value)
                            }
                          >
                            <PostAddIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )
                  }
                  {
                    hasPermission(PermissionsEnum.api_change_prospectocorporativo) && (value.estado_prospecto == EstadoProspectoEnum.EN_ESPERA) && (
                      <Grid item >
                        <Tooltip title={'Revisar Prospecto'} placement="top">
                          <IconButton
                            onClick={() =>
                              onReview(value)
                            }
                          >
                            <Visibility />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )
                  }
                  {
                    hasAllPermissions([
                      PermissionsEnum.api_change_prospectocorporativo,
                      PermissionsEnum.api_view_empleado,
                    ]) && ROL_USUARIO == RolChoiceEnum.SUPERVISOR
                    // && CANAL_VENTA_USUARIO == value?.canal_venta_create
                    && estado_prospecto == EstadoProspectoEnum.EN_ESPERA && (
                      <Grid>
                        <Tooltip placement="top" title='Cambiar'>
                          <IconButton
                            onClick={() => {
                              setChangeVendedorModal(true);
                              formChangeVendedor.reset({
                                vendedor_actual: value.user_create,
                                id_prospecto_corporativo: value.id_prospecto_corporativo
                              })
                            }}
                          >
                            <PersonSearchIcon color="info" />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )
                  }
                  {
                    hasPermission(PermissionsEnum.api_change_prospectocorporativo) && (
                      <Grid item>
                        <Tooltip title={texto.cancelado} placement="top">
                          <IconButton
                            onClick={() => {
                              setModalCancelar(true)
                              resetMotivoRechazar({
                                id_prospecto_corporativo: value.id_prospecto_corporativo,
                                identificacion: value.identificacion,
                                razon_social: value.razon_social
                              })
                            }
                            }
                          >
                            <HighlightOffIcon color="error" />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )
                  }

                </Grid>
              )
            }
            }

          />
        </Grid>
      </Grid>

      {
        changeVendedorModal && (
          <ScrollableDialogProps
            open={changeVendedorModal}
            title="Cambiar Vendedor"
            confirmTextBtn="Cambiar"
            contentNode={
              <Grid container spacing={2}>

                <CustomTextFieldNoForm
                  label="Vendedor actual"
                  value={formChangeVendedor.getValues().vendedor_actual}
                  disabled
                  size={gridSizeMdLg6}
                />

                <CustomAutocompleteDynamicSearch<Empleado>
                  size={gridSizeMdLg6}
                  label={'Asignar vendedor'}
                  name="vendedor_nuevo"
                  optionsFetched={dataEmpleadosFiltered?.data?.data || []}
                  valueKey="razon_social"
                  actualValueKey="user"
                  defaultValue={vendedor}
                  isLoadingData={isLoadingEmpleados}
                  control={formChangeVendedor.control}
                  setWrittenText={setSearchVendedor}
                  error={formChangeVendedor.formState.errors.vendedor_nuevo}
                  helperText={formChangeVendedor.formState.errors.vendedor_nuevo?.message}
                />
              </Grid>
            }
            onConfirm={formChangeVendedor.handleSubmit(async (form) => {
              await mutateAsyncProspectoCorp({
                id: form.id_prospecto_corporativo!,
                data: {
                  user_create: form.vendedor_nuevo
                }
              })
              formChangeVendedor.reset({})
              setChangeVendedorModal(false)
            })}
            onClose={() => setChangeVendedorModal(false)}
          />
        )
      }


      {/*Modal para cancelar*/}

      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={`Estás a punto de cancelar un prospecto del cliente ${formRechazo.getValues().razon_social}
          con la identificación ${formRechazo.getValues().identificacion}. ¿Estás seguro? Este cambio es irreversible.`}
          contentNode={
            <Grid container spacing={3}>

              <CustomAutocomplete<MotivoRechazo>
                label="Motivo de rechazo"
                name="motivo_rechazo"
                // options
                options={motivosRechazoPaging?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ''}
                isLoadingData={isLoadingMotivosRechazo || isRefetchingMotivosRechazo}
                // validation
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={formRechazo?.formState?.errors.motivo_rechazo?.message}
                disableClearable
              />

              <CustomTextArea
                label="Observación"
                name="observacion_cancelacion"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={formRechazo.getValues().observacion_cancelacion ?? ''}
                error={formRechazo.formState.errors.observacion_cancelacion}
                helperText={formRechazo.formState.errors.observacion_cancelacion?.message}
                required={false}
              />
            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(async () => {
            const resp = await mutateAsyncProspectoCorp({
              id: formRechazo.getValues().id_prospecto_corporativo!,
              data: {
                estado_prospecto: EstadoProspectoEnum.CANCELADO,
                motivo_rechazo: formRechazo.getValues().motivo_rechazo,
                observaciones: {
                  observacion_cancelar: formRechazo.getValues().observacion_cancelacion
                }
              }
            });
            if (resp.code === 200) {
              resetMotivoRechazar({ id_prospecto_corporativo: '', motivo_rechazo: '' });
              setModalCancelar(false);
            }
          })}
          onClose={() => {
            resetMotivoRechazar({ id_prospecto_corporativo: '', motivo_rechazo: '' });
            setModalCancelar(false)
          }}
        />
      )}


      {/*Modal para editar numero de celular*/}

      {modal && (
        <ScrollableDialogProps
          open={modal}
          title="Editar Información de Prospecto"
          confirmTextBtn="Cambiar"
          contentNode={
            <Grid container spacing={3}>
              <CustomTextFieldNumberComponente
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={control}
                name="celular"
                defaultValue={form.getValues().celular || ''}
              />
            </Grid>
          }
          onConfirm={form.handleSubmit(async () => {
            await mutateAsyncProspectoCorp({
              id: form.getValues().id_prospecto,
              data: {
                celular: form.getValues().celular
              }
            });
            reset({ celular: '', id_prospecto: '' });
            setModal(false);
          })}
          onClose={() => setModal(false)}
        />
      )
      }


    </>

  );



}